import gql from 'graphql-tag'

let cities = JSON.parse(localStorage.getItem('cities'))
let finalCondition = '';
let intermediateCondition = '';
if(cities && cities.length){
  let territoryCities = cities.map(curnt => curnt.city);
  finalCondition = ', {city: {_in: '+ JSON.stringify(territoryCities) +'}}'
}

export const SEARCH_CITY = gql`
  query territories($cityFilter: String!){
    territories
    (where:{city:{_ilike:$cityFilter}},distinct_on: city, order_by: {city: asc})
    {
      id
      city
      cityCode
    }
  }
`

export const SEARCH_CITY2 = gql`
  query city($cityFilter: String!){
    city
    (where: {_and: [{city:{_ilike:$cityFilter}}${finalCondition}]}, distinct_on: city, order_by: {city: asc})
    {
      city
      shortCode
      state
      id
    }
  }
`
export const EXCEPTIONAL_CITY_MANAGER_SEARCH_CITY2 = gql`
  query city($cityFilter: String!){
    city
    (where: {_and: [{city:{_ilike:$cityFilter}}]}, distinct_on: city, order_by: {city: asc})
    {
      city
      shortCode
      state
      id
    }
  }
`
export const GET_ALL_CITIES = gql`
  query allCities{
    city{
      city
      id
    }
  }
`
export const GET_CITY_BY_NAME = gql`
  query getCityByName($name: String!){
    city(where:{city:{_eq:$name}}){
      city
      id
    }
  }
`
export const SEARCH_AREAGROUP = gql`
  query areaGroups($groupFilter: String!){
    areaGroups
    (where:{name:{_ilike:$groupFilter}},distinct_on: name, order_by: {name: asc})
    {
      name
      id
    }
  }
`

export const SEARCH_STATE = gql`
 query territories($stateFilter: String!){
    territories
     (where:{state:{_ilike:$stateFilter}},distinct_on: state, order_by: {state: asc})
     {
      id
      state
  }
}`


